export default __webpack_public_path__ + "static/media/insertar.dbea6f3a.svg";